<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入DID" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="Time" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    			</el-form-item>
				<el-form-item>
					<!--<el-button type="primary" size="small" @click="Find">查询</el-button>-->
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
		    <el-table-column fixed label="设备DID" prop="did" width="150"></el-table-column>
<!--			<el-table-column label="设备版本" width="80" prop="f1" :formatter="f1Format"></el-table-column>-->
			<el-table-column label="软件  版本号" width="65" prop="f2" :formatter="f2Format"></el-table-column>
			<el-table-column label="发送时间" width="180" prop="f30" :formatter="dateFormat"></el-table-column>
			<el-table-column label="开机时长" width="120">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f3)}}</span>
				</template>
			</el-table-column>
<!--			<el-table-column label="站立时长" width="120">-->
<!--				<template slot-scope="scope">-->
<!--					<span>{{timeformat(scope.row.f4)}}</span>-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column label="机器运行里程" width="120">
				<template slot-scope="scope">
					<span>{{scope.row.f5}} 米</span>
				</template>
			</el-table-column>
			<el-table-column label="蹲起切换次数" width="120">
				<template slot-scope="scope">
					<span>{{scope.row.f6}} 次</span>
				</template>
			</el-table-column>
<!--			<el-table-column label="蹲起总次数" width="120">-->
<!--				<template slot-scope="scope">-->
<!--					<span>{{scope.row.f7}} 次</span>-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column label="SOS次数" width="80">
				<template slot-scope="scope">
					<span>{{scope.row.f8}} 次</span>
				</template>
			</el-table-column>
<!--			<el-table-column label="训练模式次数" width="120">-->
<!--				<template slot-scope="scope">-->
<!--					<span>{{scope.row.f9}} 次</span>-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column label="站立状态下高速时间" >
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f10)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="站立状态下低速时间" >
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f11)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="限速次数" width="90">
				<template slot-scope="scope">
					<span>{{scope.row.f12}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="倾斜次数" >
				<template slot-scope="scope">
					<span>{{scope.row.f13}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="颠簸次数">
				<template slot-scope="scope">
					<span>{{scope.row.f14}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="急转次数" >
				<template slot-scope="scope">
					<span>{{scope.row.f15}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="轮毂电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f16)}}</span>
				</template>
			</el-table-column>
			
			<el-table-column label="座椅电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f17)}}</span>
				</template>
			</el-table-column>
			<!--原缠绕带电机使用时长 f17
			原座椅电机使用时长     f18-->
			<el-table-column label="缠绕带电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f18)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="升降电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f19)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="推杆电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f20)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="脚踏电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f21)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="锁定按键" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.f22}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="缠绕带in按键" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f23}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="缠绕带out按键" width="120">
				<template slot-scope="scope">
					<span>{{scope.row.f24}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="座椅up键" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.f25}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="座椅down键" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f26}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="速度按键" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.f27}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="SOS按键" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.f28}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="开关机按键" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.f29}} 次</span>
				</template>
			</el-table-column>
			
			
			
			
			<el-table-column fixed="right" label="接收时间" prop="time" width="180" :formatter="dateFormat"></el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetDevSportflashlogslist} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:500,
				Time:"",
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				List:[],
				Findform:"",
				inputMac:""
			}
		},
		methods:{
			timeformat(val){
				return val + "秒"
//				var mint = Math.round(val/60)%60
//				var hour = (Math.round(val/60) - Math.round(val/60)%60)/60
//				if(mint == 0 && hour == 0){
//					return 0 + "分钟"
//				}else if(hour == 0){
//					return mint + "分钟"
//				}else if(mint == 0 ){
//					return hour + "小时"
//				}else{
//					return hour + "小时" + mint + "分钟"
//				}
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Find()
			},
			BeforeFind(){
				this.Curpage = 1
				this.Find()
			},
			f1Format(row,column){
				if(row[column.property]){
					let d1 = row[column.property]
					if(d1 == "1"){return "运动版"}
//					else if(d1 == "2"){return "医用版"}
//					else if(d1 == "3"){return "老年版"}
//					else if(d1 == "4"){return "智能版"}
					else {return row[column.property]}
				}else{
					return "无"
				}
			},
			f2Format(row,column){
				if(row[column.property]){
					let bb = row[column.property] + ""
					return "v" + bb.substring(0,1) + "." + bb.substring(1)
				}else{
					return "无"
				}
			},
			Find(){
				if(this.Time){
					this.Betweenall = {"BETWEEN":{'time':[this.Time[0]/1000,this.Time[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'did':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetList(GetDevSportflashlogslist,{page:this.Curpage,token:this.token,sort:"-time",q:ever2})
				}else{
					this.GetList(GetDevSportflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
				}
			},
			Refresh(){
				this.Time = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetList(GetDevSportflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			}
	},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetDevSportflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SportFlash.vue?bb559ebe